/**
 * Sprint 23.8 — workspace activity hook.
 *
 * Wraps `list_workspace_activity` for the recent-activity sidebar block.
 * Polled every 60s (Q15 — aggregate cadence). Pauses while the tab is hidden.
 */

import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { useAuth } from "../../lib/hooks/use-auth";
import type { WorkspaceActivityEvent } from "../../lib/types";

const POLL_MS = 60_000;

export function useWorkspaceActivity(limit = 5) {
  const { currentWorkspaceId } = useAuth();
  return useQuery<WorkspaceActivityEvent[]>({
    queryKey: ["workspace-activity", currentWorkspaceId, limit],
    queryFn: () => mcpClient.listWorkspaceActivity(limit),
    enabled: !!currentWorkspaceId,
    staleTime: 30_000,
    refetchInterval: POLL_MS,
    refetchOnWindowFocus: true,
  });
}
